import { Atom } from 'AppReact';
import styled, { css } from "styled-components";

const template = styled.img`
    ${({ displayState, theme }) => css`
        width: ${displayState?.width ? `${displayState?.width}` : '14px'};
        height: ${displayState?.height ? `${displayState?.height}` : '14px'};
        border-radius: ${displayState?.borderRadius ? `${displayState?.borderRadius}` : '50%;'};
        object-fit: ${displayState?.objectFit ?? 'cover'};
    `}
`;

export default Atom({ type: 'image', datatype: 'string', template })
